import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import {
  Typography,
  TypographyComponentEnum,
  TypographyVariant,
} from '@unisporkal/alliance-ui';
import styles from './DownloadsRemaining.module.scss';

type Props = { count: number };

const DownloadsRemaining: React.FC<Props> = ({ count }) => {
  const t = useTranslations();
  return (
    <Typography
      variant={TypographyVariant.body.small}
      component={TypographyComponentEnum.P}
      className={styles.helperText}
      data-testid="downloads-remaining"
    >
      {t('downloads_remaining_monthly_count', { count })}
    </Typography>
  );
};

export default DownloadsRemaining;
